import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleMinus } from "@fortawesome/free-solid-svg-icons";
import { FinancialProduct } from "./FinancialProductCard";
import "./SelectedProductCard.scss";

export interface SelectedProductCardProps {
  product: FinancialProduct;
  depositApplicationId: string;
  onDelete: (depositApplicationId: string) => void;
  className?: string;
}

export const SelectedProductCard: React.FC<SelectedProductCardProps> = ({
  product,
  depositApplicationId,
  onDelete,
  className = "",
}) => {
  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete(depositApplicationId);
  };

  return (
    <div className={`selected-product-card ${className}`}>
      <div className="selected-product-card__header">
        <h4 className="selected-product-card__title">{product.title}</h4>
        <button
          className="selected-product-card__delete-button"
          onClick={handleDelete}
          aria-label={`Remove ${product.title}`}
        >
          <FontAwesomeIcon icon={faCircleMinus} />
        </button>
      </div>
      <p className="selected-product-card__description">{product.description}</p>
    </div>
  );
};
